import React from 'react';

const PublicFooter = ({ message }) => {
  return <div style={{ fontSize: '0.8125em', color: 'rgba(33,33,33,.54)' }}>{message}</div>;
};

export default PublicFooter;
